import loadable, { LoadableComponent } from '@loadable/component';
import dynamic from 'next/dynamic';

import { HeaderAccountFlyoutProps } from '@zooplus/header-account-flyout';

const getHeaderAccountFlyout = (
    isNextJS: boolean,
):
    | React.ComponentType<HeaderAccountFlyoutProps>
    | LoadableComponent<HeaderAccountFlyoutProps> => {
    return isNextJS
        ? dynamic(() => import('@zooplus/header-account-flyout'), {
              ssr: false,
          })
        : loadable(() => import('@zooplus/header-account-flyout'));
};

export default getHeaderAccountFlyout;
